import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  display: flex;
  flex-direction: row;
  align-items: center;

  &.slim {
    .cta {
      display: none;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  min-width: 177px;
  gap: 2px;
`;

export const Cta = styled.div`
  padding: 0 10px;
`;

export const Button = styled.button`
  width: 20px;
  font-size: 12px;
  background-color: #3c4257aa;
  border: none;
  color: #999;

  // 1 8 9 16
  &:nth-child(1) {
    border-radius: 4px 0 0;
  }
  &:nth-child(8) {
    border-radius: 0 4px 0 0;
  }
  &:nth-child(9) {
    border-radius: 0 0 0 4px;
  }
  &:nth-child(16) {
    border-radius: 0 0 4px 0;
  }

  &:hover {
    background-color: #4c536baa;
  }

  &:active {
    background-color: #2c3147aa;
  }

  &:disabled {
    background-color: #2c3147;
    color: #666;
    pointer-events: none;
  }
`;

export const Total = styled.div`
  color: #62c8f4;
  font-size: 12px;
  position: relative;
  text-align: center;
  top: -5px;
`;
